<template>
    <div>
        <div v-if="!showCompany">
            <b-row>
                <b-col cols="12" md="8">
                    <b-input v-model="uuid" placeholder="Введите UUID заявки (32 символа), например: 5cb0b2aa05fd4854aa82d23e59abd745"/>
                </b-col>
                <b-col cols="12" md="4">
                    <b-button block @click="loadCompany()" :disabled="uuid && uuid.length === 32 ? false : true" variant="primary">Показать заявку</b-button>
                </b-col>
            </b-row>
        </div>
        <strong v-if="error != null" class="text-danger">{{ error }}</strong>
        <div v-if="showCompany">
            <b-row >
                <b-col>
                    <strong>UUID: {{ company.uuid }}</strong>
                    <hr/>
                    <eco-company-view
                        v-if="company.uuid"
                        :company.sync="company" 
                        :items="items" 
                        :editable="false"/>
                        <hr/>
                </b-col>
            </b-row>
            <template v-if="company && company.points">
                <h3>Точки</h3>
                <b-row v-for="(item, index1) of company.points" :key="index1">
                    <b-col class="text-right" cols="12" md="4">
                        {{ item.name }}
                    </b-col>
                    <b-col cols="12" md="8">
                        {{ item.address }}<br/>
                        Тип контейнера: {{ item.type }}
                        <hr/>
                    </b-col>
                </b-row>
            </template>
            <template v-if="company && company.files">
                <h3>Файлы</h3>
                <b-row v-for="(item, index2) of company.files" :key="index2 + 100">
                    <b-col class="text-right" cols="12" md="4">
                        {{ item.title }}
                    </b-col>
                    <b-col cols="12" md="8">
                        <a :href="filelink(item.uuid)" target="blank">{{ item.source }}</a>
                        <hr/>
                    </b-col>
                </b-row>
            </template>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    props:{
        uuid: String
    },
    methods:{
        filelink(fuid) {
            return `${window.$apiurl}/download?get=${this.company.uuid}:${fuid}`
        },
        loadCompany() {
            this.error = null
            if(this.uuid && this.uuid.length === 32) {
                axios.get(window.$apiurl + '/show', { params: { uuid: this.uuid }})
                .then(res => {
                    if(res.data.status === 'ok'){
                        if(res.data.data && res.data.data.uuid === this.uuid) this.company = res.data.data
                        else if(res.data.data) {
                            if(res.data.data === 'notfound') this.error = 'С таким UUID ничего не найдено, проверьте и повторите заново.'
                            if(res.data.data === 'baduid') this.error = 'Некорректиный UUID, проверьте и повторите заново.'
                        } else  this.error = 'Неизвестная ошибка.'
                    }
                })
                .catch( err => this.error = `Ошибка сети. Причины: отсутствует соединение с сетью Интернет или сервис в данный момент недоступен по техническим причинам [ ${err} ]` )
            }
        }
    },
    data() {
        return {
            error: null,
            company: {
                uuid: null
            },
            items: [
                'opf.full', 'opf.short', 
                'name.full', 'name.short', 
                'id.inn', 'id.kpp', 'id.ogrn', 'id.date', 'id.okved',
                'ceo.post', 'ceo.name',
                'address.value',  
                'contacts.phone',
                'contacts.email',
                'contacts.website', 
                'edo.use',
                'edo.name', 
            ]
        }
    },
    mounted() {
        this.loadCompany()
    },
    computed: {
        showCompany() {
            if(this.uuid && this.uuid.length === 32 && this.company.uuid && this.company.uuid.length === 32) {
                return true
            } return false
        }
    }
}
</script>